// extracted by mini-css-extract-plugin
module.exports = {"splashRoot":"splash_splashRoot__1j5dG","links":"splash_links__1c-DY"};